import React from "react";
import {cx} from "../../lib/ClassSet";
import "./CreditCardItem.css";
import format from 'date-fns/format'
import ContextMenuTrigger from "../../components/ContextMenuTrigger";
import { formatExpirationDate, getCardDescription } from "../../lib/Money";

const CreditCardItem = (props) => {

  let {data} = props;
  let classes = cx({
    "item": true,
    "credit-card-list-item": true,
    "u-default": data.get("default")
  })

  let contextClickFn = (x, y) => props.onContextMenuClick(data.get("paymentMethodId"), x, y)
  let brand = getCardDescription(data.get("type"), data.get("cardBrand"));

  return (
    <tr className={classes}>
      <td className="field f-id">{data.get("paymentMethodId")} <span className="default">(Default)</span></td>
      <td className="field f-brand">{brand}</td>
      <td className="field f-id">**** {data.get("cardLast4")}</td>
      <td className="field">{formatExpirationDate(data.get("cardExpMonth"), data.get("cardExpYear"))}</td>
      <td className="field f-date">{format(data.get("addedAt"), "MMM D, YYYY")}</td>
      <td className="field f-context"><ContextMenuTrigger onClick={contextClickFn}/></td>
    </tr>
  )
}

export default CreditCardItem;